export default __webpack_public_path__ + "static/media/breach1.192a1f3d.png";